import BaseFactory from 'services/sports/default/base-factory';
import Player from './player';

class Factory extends BaseFactory {
    createObj(objectName, params) {
        return new Player(params);
    }
}

export {Factory};
